import React from "react";
import { useLang } from "@/context/LanguageContext";

// Shared translation component (prompt 3A-C: "All text goes through the shared
// translation function"). Wrap hardcoded English UI text: <T>My Bookings</T>.
// The English text itself is the key. It resolves to the active language's
// published translation; when none exists it shows the English WITH a semantic
// marker (prompt 3A-D: never show English as if it were translated).
export function T({ children }) {
  const { tx } = useLang();
  const raw =
    typeof children === "string"
      ? children
      : Array.isArray(children)
      ? children.filter((c) => typeof c === "string").join("")
      : "";
  const { text, pending, lang } = tx(raw);
  if (!pending) return <>{text}</>;
  return (
    <span className="dh-i18n-fallback" lang="en" data-untranslated={lang}>
      {text}
    </span>
  );
}

export default T;
